import service from "@/api/service";
import { GetResponse } from "@/api/analysis/shop-coupon-list/response";
import { GetRequest } from "@/api/analysis/shop-coupon-list/request";

/**
 * クーポン情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/analysis-shop-coupon-list", getRequest);
  return response.data as GetResponse;
}
